"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubReactionChuteBrusqueValeurInvestissementCorporation = void 0;
exports.ESubReactionChuteBrusqueValeurInvestissementCorporation = {
    vendre: "vendre",
    conserver: "conserver",
    investir: "investir",
};
